import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { Card } from '../types/models';

export interface DeadlineStats {
  date: string;
  cardCount: number;
}

export interface DeadlineStatsResponse {
  startDate: string;
  endDate: string;
  stats: DeadlineStats[];
  maxCount: number;
}

/**
 * Get deadline statistics for a board
 */
export const useDeadlineStats = (boardId: number, startDate: string, endDate: string) => {
  return useQuery<DeadlineStatsResponse>({
    queryKey: ['boards', boardId, 'deadlines', 'stats', startDate, endDate],
    queryFn: async () => {
      return await apiClient.get<DeadlineStatsResponse>(
        `/boards/${boardId}/deadlines/stats`,
        {
          params: { startDate, endDate },
        }
      );
    },
    enabled: !!boardId && !!startDate && !!endDate,
    staleTime: 60000, // Cache for 1 minute
  });
};

/**
 * Get cards by due date
 */
export const useCardsByDueDate = (boardId: number, date: string, enabled: boolean = true) => {
  return useQuery<Card[]>({
    queryKey: ['boards', boardId, 'deadlines', 'date', date],
    queryFn: async () => {
      return await apiClient.get<Card[]>(`/boards/${boardId}/deadlines/date/${date}`);
    },
    enabled: enabled && !!boardId && !!date,
    staleTime: 30000, // Cache for 30 seconds
  });
};
